import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { OutletModule } from '@spartacus/storefront'
import { ModalComponent } from '../../shared/modal/modal.component'
import { CustomProductSummaryComponent } from './custom-product-summary.component'

@NgModule({
  imports: [CommonModule, OutletModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductSummaryComponent: {
          component: CustomProductSummaryComponent
        }
      }
    })
  ],
  declarations: [CustomProductSummaryComponent, ModalComponent],
  exports: [CustomProductSummaryComponent]
})
export class CustomProductSummaryModule {}
